import jQuery from 'jquery';
(window as any)['jQuery'] = jQuery;
(window as any)['$'] = jQuery;

import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from 'app/app.component';
import { appConfig } from 'app/app.config';
import { environment } from 'environments/environment';
import { EnvironmentValidator } from 'app/core/config/environment-validator';

// Validate environment configuration for security
EnvironmentValidator.validate(environment);

function getCookieValue(name: string): string {
    const prefix = `${name}=`;
    const row = document.cookie
        .split('; ')
        .find((entry) => entry.startsWith(prefix));

    return row ? row.slice(prefix.length) : '';
}

function installNoncePropagation(): void {
    const nonce = document.querySelector('meta[name="csp-nonce"]')?.getAttribute('content') || getCookieValue('csp-nonce');
    if (!nonce) {
        return;
    }

    const applyNonce = (node: Node | null): void => {
        if (!(node instanceof HTMLElement)) {
            return;
        }

        const tag = node.tagName.toLowerCase();
        if ((tag === 'style' || tag === 'script') && !node.getAttribute('nonce')) {
            node.setAttribute('nonce', nonce);
        }
    };

    // Cover style/script tags that may already exist before app bootstrap.
    document.querySelectorAll('style,script').forEach((element) => {
        if (!element.getAttribute('nonce')) {
            element.setAttribute('nonce', nonce);
        }
    });

    const originalAppendChild = Node.prototype.appendChild;
    Node.prototype.appendChild = function <T extends Node>(child: T): T {
        applyNonce(child);
        return originalAppendChild.call(this, child);
    };

    const originalInsertBefore = Node.prototype.insertBefore;
    Node.prototype.insertBefore = function <T extends Node>(newNode: T, referenceNode: Node | null): T {
        applyNonce(newNode);
        return originalInsertBefore.call(this, newNode, referenceNode);
    };
}

installNoncePropagation();

// Hide splash immediately on startup if a one-time flag is set
try {
    const suppress = sessionStorage.getItem('suppressSplashOnce');
    if (suppress === 'true') {
        document.body.classList.add('fuse-splash-screen-hidden');
        sessionStorage.removeItem('suppressSplashOnce');
    }
} catch {}

bootstrapApplication(AppComponent, appConfig).catch((err) =>
    console.error(err)
);
